<template>
  <b-card
    no-body
    class="mb-0"
  >
    <b-row>
      <b-col md="12">
        <b-form-file
          v-model="file_upload"
          :browse-text="$t('clients.select')"
          :placeholder="$t('clients.select_file_here')"
          :drop-placeholder="$t('clients.drag_file_here')"
          class="my-1"
        />
        <b-button
          class="ml-auto d-block"
          variant="primary"
          size="md"
          @click="uploadFile"
        >
          <feather-icon
            icon="UploadIcon"
            class="mr-25"
          />
          {{ $t('clients.upload') }}
        </b-button>
      </b-col>

    </b-row><hr>

    <h6 class="font-weight-bold mt-2 mb-1">
      {{ $t('clients.files_tabble') }}
    </h6>
    <b-table
      :items="items"
      :current-page="currentPage"
      :per-page="perPage"
      :fields="fields"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      small
      hover
      bordered
      select-mode="single"
      selectable
      @filtered="onFiltered"
    >
      <template #empty>
        <div class="text-center">
          {{ $t('general.no_records_to_show') }}
        </div>
      </template>
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>

      <!-- @row-selected="onRowSelected" -->
      <!-- :filter="filter" -->

      <template #cell(id)="row">
        {{ (row.index + 1) + ((currentPage-1) * perPage) }}
      </template>

      <template #cell(title)="row">
        {{ row.value }}
      </template>

      <template #cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="success"
            class="mr-50"
            size="sm"
            @click="downloadFile(row.item.file)"
          >
            <feather-icon
              icon="DownloadIcon"
              class="mr-50"
            />
            <span class="align-middle">{{ $t('generals.download') }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-before-delete-file
            variant="danger"
            class=""
            size="sm"
            @click="delete_file_id = row.item.id"
          >
            <feather-icon
              icon="Trash2Icon"
              class="mr-50"
            />
            <span class="align-middle">{{ $t('generals.delete') }}</span>
          </b-button>
        </div>
      </template>

      <!-- <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template> -->
    </b-table>
    <div class="d-flex justify-content-between align-items-center flex-wrap px-1 mb-75">
      <div class="d-flex align-items-center mt-1">
        <span class="text-nowrap">
          {{ $t('generals.show_from') }}
        </span>
        <b-form-select
          v-model="perPage"
          size="sm"
          :options="['3','5','10']"
          class="mx-1"
        />
        <span class="text-nowrap"> {{ $t('generals.rows') }} </span>
      </div>
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </div>

    <b-modal
      id="modal-before-delete-file"
      ok-title="Да"
      cancel-title="Нет"
      ok-variant="success"
      cancel-variant="danger"
      centered
      :title="$t('clients.attention')"
      @ok="deleteFile"
    >
      <b-card-text>
        {{ $t('clients.are_you_sure_to_delete') }}
      </b-card-text>
    </b-modal>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BRow, BCol, BCard, BButton, BModal, BTable, BPagination, BFormSelect, BFormFile, BCardText, VBModal,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import contentType from '@/utils/contentTypes'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    FeatherIcon,
    BFormFile,
    BPagination,
    BFormSelect,
    BRow,
    BCol,
    BCard,
    BTable,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      file_upload: null,
      delete_file_id: '',
      items: [],
      fields: [
        {
          label: '№',
          key: 'id',
          class: 'text-center',
          tdClass: ['idClass'],
        },
        {
          label: 'generals.name',
          key: 'title',
          class: 'text-left',
          tdClass: ['fileClass'],
        },
        {
          label: 'clients.actions',
          key: 'actions',
          class: 'text-center',
          tdClass: ['actionsClass'],
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      myContentType: {},
    }
  },
  computed: {
    ...mapGetters('clients', ['getAttachmentFiles']),

  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('clients', ['UPLOAD_ATTACHMENT_FILE', 'GET_ATTACHMENT_FILES', 'DELETE_ATTACHMENT_FILE']),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async refresh() {
      await this.GET_ATTACHMENT_FILES({ object_id: this.$route.params.id, content_type: contentType['clients/client'] })
      this.items = []
      this.getAttachmentFiles.results.forEach(elem => {
        // eslint-disable-next-line no-param-reassign
        elem.title = elem.file.split('/')[elem.file.split('/').length - 1]
        this.items.push(elem)
      })
      this.totalRows = this.items.length
    },
    downloadFile(url) {
      const url_parts = url.split('/')
      fetch(url).then(t => t.blob().then(b => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(b)
        a.setAttribute('download', url_parts[url_parts.length - 1])
        a.click()
      }))
    },
    async deleteFile() {
      const resp = await this.DELETE_ATTACHMENT_FILE(this.delete_file_id)
      await this.refresh()
      if (resp.status === 204) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            icon: 'AlertCircleIcon',
            variant: 'success',
            text: this.$t('actions.file_deleted_succesfuly'),
          },
        })
      }
    },
    async uploadFile() {
      const fd = new FormData()

      fd.append('author', getUserData().id)
      fd.append('object_id', this.$route.params.id)
      fd.append('content_type', contentType['clients/client'])
      fd.append('file', this.file_upload)

      const resp = await this.UPLOAD_ATTACHMENT_FILE(fd)
      await this.refresh()
      if (resp.status === 201) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            icon: 'AlertCircleIcon',
            variant: 'success',
            text: this.$t('clients.file_uploaded_successfully'),
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
.idClass{
  min-width: 50px !important;
  max-width: 100px !important;
}
.fileClass{
  min-width: 50px !important;
  max-width: 350px !important;
}
.actionsClass{
  min-width: 50px !important;
  max-width: 130px !important;
}
</style>
